var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c(
        "el-breadcrumb",
        { attrs: { separator: "/" } },
        [
          _c(
            "el-breadcrumb-item",
            { staticClass: "el-bread-one", staticStyle: { color: "red" } },
            [_vm._v("仓库管理")]
          ),
          _c("el-breadcrumb-item", [_vm._v("盘点填写")]),
        ],
        1
      ),
      _c("div", { staticClass: "context" }, [
        _c("div", { staticClass: "left" }, [
          _c("div", { staticClass: "top" }, [_vm._v("盘点单")]),
          _c(
            "div",
            { staticClass: "tableBorder" },
            [
              _c("div", { staticClass: "title" }, [
                _c("span", [
                  _vm._v("盘点编号：" + _vm._s(_vm.table.oddNumber)),
                ]),
                _c("span", [
                  _c("span", { staticStyle: { "margin-right": "20px" } }, [
                    _vm._v("申请人：" + _vm._s(_vm.table.createdByName) + " "),
                  ]),
                  _c("span", [
                    _vm._v(
                      " 创建时间：" + _vm._s(_vm.$moment(_vm.table.createdTime))
                    ),
                  ]),
                ]),
              ]),
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  attrs: { data: _vm.table.goodsList },
                  on: {
                    "row-click": _vm.rowClick,
                    "selection-change": _vm.selectChange,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "55" },
                  }),
                  _c("el-table-column", {
                    attrs: { type: "index", width: "50", label: "序号" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "商品信息", prop: "title" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "实际库存", prop: "warCount" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " + _vm._s(_vm.inventoryCount(scope.row)) + " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm.obj.isFp != 1
                    ? _c("el-table-column", {
                        attrs: { label: "盘点库存" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        scope.row.warNames
                                          ? scope.row.warNames
                                          : "--"
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          411032
                        ),
                      })
                    : _vm._e(),
                  _vm.obj.isFp == 1
                    ? _c("el-table-column", {
                        attrs: {
                          label:
                            _vm.table.goodsList[0] &&
                            _vm.table.goodsList[0].checkNumberDetails
                              ? "复盘" +
                                _vm.table.goodsList[0].checkNumberDetails.length
                              : "初盘库存",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(scope.row.realTimeQuantityCopy) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3637104172
                        ),
                      })
                    : _vm._e(),
                  _c("el-table-column", {
                    attrs: { label: "差异" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.realTimeQuantity
                                    ? scope.row.realTimeQuantityCopy -
                                        scope.row.realTimeQuantity
                                    : "--"
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm.obj.isFp != 1
                    ? _c("el-table-column", {
                        attrs: { label: "盘点仓库", prop: "createdByName" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return _vm._l(
                                  scope.row.warehouses,
                                  function (item) {
                                    return !item.type
                                      ? _c("span", { key: item.warId }, [
                                          _vm._v(
                                            " " + _vm._s(item.warName) + " "
                                          ),
                                        ])
                                      : _vm._e()
                                  }
                                )
                              },
                            },
                          ],
                          null,
                          false,
                          513218051
                        ),
                      })
                    : _c("el-table-column", {
                        attrs: { label: "盘点人" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.preparedData.find(
                                        (res) =>
                                          res.label == scope.row.checkerId
                                      )
                                        ? _vm.preparedData.find(
                                            (res) =>
                                              res.label == scope.row.checkerId
                                          ).value
                                        : "--"
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "right" },
          [
            _vm._m(0),
            _vm.selectObj.id ||
            _vm.selectObj.goodsId ||
            _vm.selectArray.length > 1
              ? _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: { model: _vm.form, "label-width": "80px" },
                  },
                  [
                    (_vm.selectObj.id || _vm.selectObj.goodsId) &&
                    _vm.selectArray.length <= 1
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "商品名称" } },
                          [
                            _c("el-input", {
                              attrs: {
                                size: "small",
                                disabled: "",
                                value: _vm.selectObj.goodsName
                                  ? _vm.selectObj.goodsName
                                  : _vm.selectObj.title,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.obj.isFp != 1
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "盘点仓库" } },
                          [
                            _vm.obj.isFp != 1
                              ? _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      clearable: "",
                                      "value-key": "warId",
                                      multiple: "",
                                      size: "small",
                                      placeholder: "请选择",
                                    },
                                    on: { change: _vm.selectChangeList },
                                    model: {
                                      value: _vm.form.selectWar,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "selectWar", $$v)
                                      },
                                      expression: "form.selectWar",
                                    },
                                  },
                                  _vm._l(_vm.form.warArray, function (item) {
                                    return _c("el-option", {
                                      key: item.warId,
                                      attrs: {
                                        label: item.warName,
                                        value: item,
                                      },
                                    })
                                  }),
                                  1
                                )
                              : _c("el-input", {
                                  attrs: {
                                    size: "small",
                                    disabled: "",
                                    value: _vm.selectObj.warNames,
                                  },
                                }),
                          ],
                          1
                        )
                      : _vm._e(),
                    (_vm.selectObj.id || _vm.selectObj.goodsId) &&
                    _vm.selectArray.length <= 1 &&
                    _vm.obj.isFp == 1
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "实际库存" } },
                          [
                            _c("el-input", {
                              attrs: {
                                size: "small",
                                disabled: "",
                                value: _vm.selectObj.realTimeQuantity,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.obj.isFp == 1
                      ? _c("el-form-item", { attrs: { label: "盘点库存" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between",
                                "align-items": "center",
                                "flex-wrap": "wrap",
                              },
                            },
                            [
                              (_vm.selectObj.id || _vm.selectObj.goodsId) &&
                              _vm.selectArray.length <= 1
                                ? _c("el-input-number", {
                                    staticStyle: { width: "170px" },
                                    attrs: { size: "small", min: 0 },
                                    model: {
                                      value: _vm.selectObj.realTimeQuantityCopy,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectObj,
                                          "realTimeQuantityCopy",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "selectObj.realTimeQuantityCopy",
                                    },
                                  })
                                : _vm._e(),
                              _c(
                                "div",
                                { staticStyle: { display: "flex" } },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { "margin-right": "10px" } },
                                    [_vm._v("盘点人")]
                                  ),
                                  (_vm.selectObj.id || _vm.selectObj.goodsId) &&
                                  _vm.selectArray.length <= 1
                                    ? _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "150px" },
                                          attrs: {
                                            clearable: "",
                                            size: "small",
                                            placeholder: "请选择盘点人姓名",
                                          },
                                          model: {
                                            value: _vm.selectObj.checkerId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.selectObj,
                                                "checkerId",
                                                $$v
                                              )
                                            },
                                            expression: "selectObj.checkerId",
                                          },
                                        },
                                        _vm._l(
                                          _vm.preparedData,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.label,
                                              attrs: {
                                                label: item.value,
                                                value: item.label,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      )
                                    : _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "170px" },
                                          attrs: {
                                            size: "small",
                                            clearable: "",
                                            placeholder: "请选择制单人姓名",
                                          },
                                          on: { change: _vm.test },
                                          model: {
                                            value: _vm.checkerId,
                                            callback: function ($$v) {
                                              _vm.checkerId = $$v
                                            },
                                            expression: "checkerId",
                                          },
                                        },
                                        _vm._l(
                                          _vm.preparedData,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.label,
                                              attrs: {
                                                label: item.value,
                                                value: item.label,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                )
              : _c("div", { staticClass: "nodate" }, [
                  _c("img", {
                    attrs: { src: require("@/assets/kong.png"), alt: "" },
                  }),
                  _c("span", [_vm._v("请选择左侧信息")]),
                ]),
          ],
          1
        ),
      ]),
      _c("div", { staticStyle: { height: "50px" } }),
      _c(
        "div",
        { staticClass: "submit" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini" },
              on: {
                click: function ($event) {
                  return _vm.$router.go(-1)
                },
              },
            },
            [_vm._v("取消")]
          ),
          _vm.obj.isFp
            ? _c(
                "el-button",
                {
                  staticStyle: {
                    color: "#4168e7",
                    border: "1px solid #4168e7",
                  },
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      return _vm.addCheck(3)
                    },
                  },
                },
                [_vm._v("完成")]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.addCheck(1)
                },
              },
            },
            [_vm._v(_vm._s(_vm.obj.isFp == 1 ? "保存" : "添加"))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title" }, [_c("span", [_vm._v("操作")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }